import SolarMapView from './SolarMapView';

export default SolarMapView;
